<template>
    <div class="filed">
        <div 
            class="tsa-input-wrap" 
            :class="[{'is-disabled': inputDisabled}]"
            v-if="type !== 'textarea'"
        >
            <input ref="input" :disabled="inputDisabled" :readonly="readonly" :type="type" :value="value" @input="handleInput" @blur="handleBlur" v-bind="$attrs" />
        </div>
        <div class="tsa-textarea-wrap" v-else>
            <textarea 
                ref="textarea"
                v-bind="$attrs"
                @input="handleInput" 
                @blur="handleBlur"
                :value="value"
                :readonly="readonly"
                :disabled="inputDisabled"
            >
            </textarea>
            <span v-if="isWordLimitVisible && type === 'textarea'" class="el-input__count">{{ textLength }}/{{ upperLimit }}</span>
        </div>
    </div>
</template>

<script>
import emitter from '@/mixins/emitter.js';
export default {
    name: 'TsaInput',
    componentName:'TsaInput',
    inheritAttrs: false,
    props: {
        disabled: Boolean,
        readonly: Boolean,
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: String,
        },
        validateEvent: {
            type: Boolean,
            default: true
        },
        // textarea
        showWordLimit: {
            type: Boolean,
            default: false
        },
    },
    mixins: [emitter],
    data () {
        return {
            focused: false,
        }
    },
    components: {},
    computed: {
        isWordLimitVisible() {
            return this.showWordLimit &&
                this.$attrs.maxlength &&
                (this.type === 'text' || this.type === 'textarea') &&
                !this.inputDisabled &&
                !this.readonly &&
                !this.showPassword;
        },
        upperLimit() {
            return this.$attrs.maxlength;
        },
        textLength() {
            if (typeof this.value === 'number') {
                return String(this.value).length;
            }
            return (this.value || '').length;
        },
        inputExceed() {
            return this.isWordLimitVisible && (this.textLength > this.upperLimit);
        },
        inputDisabled() {
            return this.disabled;
        },
    },
    created() {},
    mounted() {},
    watch: {
        value(val) {
            if (this.validateEvent) {
                this.dispatch('TsaFormItem', 'tsa.form.change', [val]);
            }
        },
    },
    methods: {
        focus() {
            this.getInput().focus();
        },
        blur() {
            this.getInput().blur();
        },
        handleBlur(event) {
            this.$emit('blur', event);
            if (this.validateEvent) {
                this.dispatch('TsaFormItem', 'tsa.form.blur', [this.value]);
            }
        },
        handleInput(e) {
            this.$emit('input', e.target.value)
            // 可能会有嵌套
            const findParent = (parent) => {
                while (parent) {
                    if (parent.$options.name === 'TsaFormItem') {
                        break
                    } else {
                        parent = parent.$parent
                    }
                }
                return parent
            }
            const parent = findParent(this.$parent)
            if (parent) {
                parent.$emit('validate')
            }
        },
        handleChange(event) {
            this.$emit('change', event.target.value);
        },
        getInput() {
            return this.$refs.input;
        },
    },
}

</script>
<style scoped lang='less'>
.filed{
    .tsa-input-wrap{
        padding: 6PX 10PX;
        border-radius: 4PX;
        background-color: #F3F3F3;
        input{
            color: #333;
            font-size: 14PX;
            border: 0;
            background-color: transparent;
            resize: none;
            width: 100%;
        }
    }
    .is-disabled{
        background-color: #F9F9F9;
        input{
            color: #999;
            cursor: not-allowed;
        }
    }
    .tsa-textarea-wrap{
        padding: 6PX 10PX 30PX 10PX;
        border-radius: 4PX;
        background-color: #F3F3F3;
        position: relative;
        box-sizing: border-box;
        textarea{
            color: #333;
            font-size: 14PX;
            border: 0;
            background-color: transparent;
            resize: none;
            width: 100%;
        }
        span{
            position: absolute;
            bottom: 6PX;
            right: 10PX;
            font-size: 14PX;
            color: #666;
        }
    }
}
@media screen and (max-width: 750px) {
    .filed{
        .tsa-input-wrap{
            padding: 14px 24px;
            border-radius: 8px;
            input{
                display: block;
                font-size: 24px;
            }
        }
        .tsa-textarea-wrap{
            padding: 12px 20px 60px 20px;
            border-radius: 8px;
            textarea{
                font-size: 24px;
            }
            span{
                bottom: 12px;
                right: 20px;
                font-size: 24px;
            }
        }
    }
}
</style>